package core.validation.validator

import core.dateformat.utils.parseLocalDateOrNull

object DateValidator : Validator<String> {
    override val errorMessage: String
        get() = "Invalid date format."

    override fun validate(value: String): Boolean =
        parseLocalDateOrNull(value) != null
}